import { c as _c } from "react/compiler-runtime";
import { UseHotelFiltersFormProperties } from "@website/accommodation-ui/hotel-filter/hotel-filter.types";
import { numberConvert } from "@website/utils/number-convert";
import { Filters } from "@website/widget/filter";
import { FC } from "react";
export const HotelFilter: FC<UseHotelFiltersFormProperties> = properties => {
  const $ = _c(10);
  const {
    filtersSchema,
    mapFilterProps,
    trackingCallback,
    hotelListResultsCount,
    loading,
    isNewPlP
  } = properties;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      size: "small",
      color: "secondary",
      variant: "text"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = hotelListResultsCount === "loading" || loading;
  const t2 = hotelListResultsCount ?? 0;
  let t3;
  if ($[1] !== t2) {
    t3 = numberConvert(t2, {
      locale: "fa"
    });
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = `مشاهده ${t3} نتیجه`;
  let t5;
  if ($[3] !== filtersSchema || $[4] !== isNewPlP || $[5] !== mapFilterProps || $[6] !== t1 || $[7] !== t4 || $[8] !== trackingCallback) {
    t5 = <Filters isNewPlP={isNewPlP} mapFilterProps={mapFilterProps} trackingCallback={trackingCallback} resetButtonProps={t0} schema={filtersSchema} title={"\u0641\u06CC\u0644\u062A\u0631\u0647\u0627"} loading={t1} filtersActionTitle={t4} filtersClassName="xl:!max-h-[calc(100vh-96px)]" />;
    $[3] = filtersSchema;
    $[4] = isNewPlP;
    $[5] = mapFilterProps;
    $[6] = t1;
    $[7] = t4;
    $[8] = trackingCallback;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};